// 个人中心

export default [
  // 个人中心首页
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    redirect: '/PersonalCenter/MyActivities',
    component: () =>
    import(/* webpackChunkName: "PersonalCenter" */ '@/components/personal-center'),
    children: [
      // 我的活动
      {
        path: 'MyActivities',
        name: 'MyActivities',
        meta: {
          IndexHeader: true
        },
        component: () =>
        import(/* webpackChunkName: "MyActivities" */ '@/components/personal-center/my-activities')
      },
      // 我的订单
      {
        path: 'MyOrder',
        name: 'MyOrder',
        meta: {
          IndexHeader: true
        },
        component: () =>
        import(/* webpackChunkName: "MyOrder" */ '@/components/personal-center/my-order')
      },
      // 个人资料
      {
        path: 'UserCenter',
        name: 'UserCenter',
        meta: {
          IndexHeader: true
        },
        component: () =>
        import(/* webpackChunkName: "UserCenter" */ '@/components/personal-center/user-center')
      },
      {
        path: 'AccountSettings',
        name: 'AccountSettings',
        meta: {
          IndexHeader: true
        },
        component: () =>
        import(/* webpackChunkName: "AccountSettings" */ '@/components/personal-center/account-settings')
      },
      {
        path: 'MyCouponList',
        name: 'MyCouponList',
        meta: {
          IndexHeader: true
        },
        component: () =>
        import(/* webpackChunkName: "AccountSettings" */ '@/components/personal-center/my-couponlist')
      }
    ]
  },
  {
    path: '/MyActivities',
    name: 'MyActivities',
    component: () =>
    import(/* webpackChunkName: "MyActivities" */ '@/components/personal-center/my-activities')
  },
  // 重置密码
  {
    path: '/recoverPassword',
    name: 'recoverPassword',
    component: () =>
    import(/* webpackChunkName: "PersonalCenter" */ '@/components/personal-center/user-center/recoverPassword')
  },
  // 用户协议，隐私政策
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: () =>
    import(/* webpackChunkName: "PersonalCenter" */ '@/components/personal-center/user-center/userAgreement')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/personal-center.js